import {
  Account,
  AccountsResponse,
  AccountsOverviewResponse,
  AccountStatus,
} from "../entities/Accounts";

// API response structure for accounts endpoint
export interface ApiAccountsResponse {
  code: string;
  message: string;
  data: ApiAccount[];
}

// Reflects backend's CustomerAccountSummaryResponse
// (GET /customers/{clientId}/accounts) exactly - no field invented here.
export interface ApiAccount {
  accountNumber: string;
  type: string;
  typeName: string;
  key: string;
  devise: string;
  accountAgency: string;
  accountOpenDate: string; // ISO date, e.g. "2026-09-24"
  accountCloseDate: string | null;
  managerCode: string;
  iban: string;
  balance: number | null;
}

export class AccountsMapper {
  static toDomainModel(apiResponse: ApiAccountsResponse): AccountsResponse {
    return {
      code: apiResponse.code,
      message: apiResponse.message,
      data: apiResponse.data.map((item) => this.toDomainItem(item)),
    };
  }

  static toDomainOverview(
    apiResponse: ApiAccountsResponse
  ): AccountsOverviewResponse {
    return {
      code: apiResponse.code,
      message: apiResponse.message,
      data: apiResponse.data.map((item) => this.toDomainItem(item)),
    };
  }

  static toDomainItem(apiItem: ApiAccount): Account {
    return {
      id: apiItem.accountNumber,
      product: apiItem.typeName || apiItem.type || "",
      reference: apiItem.accountNumber || "",
      status: this.mapStatus(apiItem.accountCloseDate),
      balance: apiItem.balance,
      currency: apiItem.devise || "XOF",
      iban: apiItem.iban || null,
      openAt: this.formatDate(apiItem.accountOpenDate),
      accountNumber: apiItem.accountNumber,
    };
  }

  static toDomainItems(apiItems: ApiAccount[]): Account[] {
    return apiItems.map((item) => this.toDomainItem(item));
  }

  /**
   * Le backend ne renvoie pas de statut explicite sur ce compte CBS : seule la date de clôture le
   * distingue d'un compte actif.
   */
  private static mapStatus(accountCloseDate: string | null): AccountStatus {
    return accountCloseDate ? "CLOSED" : "ACTIVE";
  }

  private static formatDate(dateString: string): string {
    if (!dateString) return "";
    return dateString;
  }
}
